
<template>
  <component :is="comp" :inNote="note" @noteViewChange="noteViewChange" />
</template>
<script>

import TextNote from "./NoteView.vue";
import TemplateNote from "./Templated/TemplatedNoteView.vue";
const NotesService = require("Services/NotesService");
import MixpanelService from "Services/MixpanelService";
import { shallowRef } from "vue";

export default {
  name: "NoteEntryPoint",
  components: { TextNote, TemplateNote },
  data () {
    return {
      comp: undefined,
      currComp: '',
      noteId: this.noteId,
      note: undefined,
      views: ['no_template', 'soap']
    };
  },
  async mounted () {
    let useURLView = this.$route.query.view && this.views.includes(this.$route.query.view);
    if (useURLView) {
      switch (this.$route.query.view) {
        case ("no_template"):
          this.comp = shallowRef(TextNote);
          this.currComp = "no_template"; break;
        case ("soap"):
          this.comp = shallowRef(TemplateNote);
          this.currComp = "soap"; break;
      }
    }
    await NotesService.GetNote(this.$route.params.noteId)
      .then((resp) => {
        this.note = resp.data;
        if (!useURLView) {
          if (!this.note || this.note.note_templates.length === 0) {
            this.comp = shallowRef(TextNote);
            this.currComp = "no_template";
          }
          else {
            this.comp = shallowRef(TemplateNote);
            this.currComp = "soap";
          }
        }
      }).catch((err) => {
        console.log(err);
        this.$router.push('/notes');
        this.$toast.error({ message: "There was an error with retrieving this note!" });
      });

    this.$router.replace({ query: { view: this.currComp } });
    this.updateLatestPreferredView(this.currComp);
  },
  methods: {
    noteViewChange (view) {
      switch (this.currComp) {
        case ("no_template"):
          this.comp = shallowRef(TemplateNote);
          this.currComp = "soap";
          break;
        case ("soap"):
          this.comp = shallowRef(TextNote);
          this.currComp = "no_template";
          break;
      }
      this.$router.replace({ query: { view: this.currComp } });
      this.updateLatestPreferredView(this.currComp);
      this.logViewChange(this.currComp);
    },
    updateLatestPreferredView (view) {
      if (this.views.includes(view)) {
        this.note.metadata.user_preferred_view = view;
        if (this.note.state == 0 || this.note.state == 5) return; // guard writing when note is not processed
        NotesService.UpdateNote({ note_id: this.note.id,title: this.note.title, metadata: this.note.metadata })
          .catch(e => console.warn(e));
      } else {
        console.warn("unexpected note view selection: ", view);
      }
    },
    logViewChange (view) {
      let subId = this.$store.getters.getSubscriptionId;
      MixpanelService.Track("AdminPortal:NotesViewSelection", {
        subscription_id: subId,
        note_id: this.noteId,
        view: view,
      });
    }
  },
};
</script>